// extracted by mini-css-extract-plugin
export default {"criterionColor":"CriterionLabel_criterionColor__4S406"};